module.exports = __webpack_public_path__ + "static/media/point.abe2e5e3.png";